import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import './style.scss';
import { RECRUITER_WORKFLOW_STATUS } from '../../../../recruiter/constants/recruiter-workflow';

export class CandidateProfileAssociatedRecruiterLabel {
    talentExpertLabel = '';

    /* @ngInject */
    constructor($filter, $stateParams, $state) {
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$state = $state;
    }

    $onChanges() {
        const { candidateRecruiter, currentRecruiter, currentWorkflowStatus } = this;

        if (_.get(this.$state, '$current.includes.recruiter')) {
            this.talentExpertLabel = this.getTalentExpertLabel(candidateRecruiter, currentRecruiter, currentWorkflowStatus);
        }
    }

    getTalentExpertLabel(candidateRecruiter = {}, currentRecruiter = { _id: this.$stateParams.recruiterId }, currentWorkflowStatus = '') {
        const { fullName: recruiterName } = candidateRecruiter;

        if (this.isNoneStatus(currentWorkflowStatus)) {
            const noneLabel = this.$filter('translate')('NONE_LABEL');

            return `${noneLabel} (<span class="strike-through">${recruiterName}</span>)`;
        }

        if (candidateRecruiter._id === currentRecruiter._id) {
            const meLabel = this.$filter('translate')('ME_LABEL');

            return `${meLabel} (${recruiterName})`;
        }

        return recruiterName;
    }

    isNoneStatus(status) {
        return [
            RECRUITER_WORKFLOW_STATUS.REJECTED,
            RECRUITER_WORKFLOW_STATUS.HIDDEN,
            RECRUITER_WORKFLOW_STATUS.PROSPECT,
        ].includes(status);
    }
}

export const CandidateProfileAssociatedRecruiterLabelConfiguration = {
    template,
    bindings: {
        currentWorkflowStatus: '<',
        candidateRecruiter: '<',
        currentRecruiter: '<',
        candidate: '<',
    },
    controller: CandidateProfileAssociatedRecruiterLabel,
    controllerAs: 'candidateProfileAssociatedRecruiterLabelCtrl',
};

angular
    .module('TALENYA-FE')
    .component('candidateProfileAssociatedRecruiterLabel', CandidateProfileAssociatedRecruiterLabelConfiguration);